import { Injectable } from '@angular/core';
import { MpoDataService } from '../data-services/mpo-data.service';

@Injectable({
    providedIn: 'root'
})
export class MpoBussinessService {
    constructor(private service: MpoDataService) {
    }
    async CreateOffer(viewModel):Promise<any>{
        return this.service.CreateOffer(viewModel);
    }
    async GetOffer(viewModel):Promise<any>{
        return this.service.GetOffer(viewModel);
    }
}